const targetElement = document.getElementById('shopify-section-template--17864196128949__image_text_qzf3LK');

const newDiv = document.createElement('div');
newDiv.className = 'new-images-div';
newDiv.style.display = 'flex';

const images = [
    'https://gotulia.com/cdn/shop/files/GlutenFree_200x.png?v=1619979496',
    'https://gotulia.com/cdn/shop/files/vegan-new_200x.png?v=1738418154',
    'https://gotulia.com/cdn/shop/files/NutFree_200x.png?v=1619979559'
];

images.forEach((imagePath, index) => {
    const img = document.createElement('img');
    img.src = imagePath;
    img.alt = `Image ${index + 1}`;
    img.style.flex = '1';
    img.style.width = '20%';
    img.style.padding = '20px';
    newDiv.appendChild(img);
});

const descriptionDiv = targetElement.querySelector('.description');

descriptionDiv.parentNode.insertBefore(newDiv, descriptionDiv.nextSibling);
